export default {
    init: (app, MaterializeForm, customGoogleMap) => {


    }
}